import type { DocumentAccessAction, DocumentAccessLogEntry } from '../../types/api';

/**
 * Pure helpers used by DocumentsActivityPage. Live in their own module so we
 * can unit test them without spinning up the whole React + Mantine + tanstack
 * tree, which is finicky to drive in jsdom for table-only assertions.
 */

export const ACCESS_ACTION_COLORS: Record<DocumentAccessAction, string> = {
  preview: 'blue',
  download: 'pine',
  archive: 'grape',
};

export interface FormattedAccessLogRow {
  id: string;
  whenLabel: string;
  actionLabel: DocumentAccessAction;
  actionColor: string;
  whoLabel: string; // username or "(deleted user)"
  whoSubLabel: string | null; // email
  documentLabel: string; // filename, "(deleted document)", or "— project archive —"
  ipLabel: string; // ip or "—"
}

export function formatAccessLogRow(
  e: DocumentAccessLogEntry,
  formatTimestamp: (iso: string) => string,
): FormattedAccessLogRow {
  return {
    id: e.id,
    whenLabel: formatTimestamp(e.created_at),
    actionLabel: e.action,
    actionColor: ACCESS_ACTION_COLORS[e.action],
    whoLabel: e.username ?? '(deleted user)',
    whoSubLabel: e.username ? e.user_email : null,
    documentLabel:
      e.action === 'archive'
        ? '— project archive —'
        : (e.original_filename ?? '(deleted document)'),
    ipLabel: e.ip_address ?? '—',
  };
}
